import React, { useState, useEffect } from "react";
import AccountRegisterForm from "./AccountRegisterForm";
import useCustomerActivationCheck from "@src/hooks/useCustomerActivationCheck";

const AccountRegisterPopup = ({ settings }) => {
    const [email, setEmail] = useState("");
    const [isValidating, setIsValidating] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(true);
    const [showRegisterForm, setShowRegisterForm] = useState(false);
    const [activationMessage, setActivationMessage] = useState("");
    const { checkCustomerActivationStatus } = useCustomerActivationCheck();
    const { section = {}, globals = {} } = settings;
    const { email_already_exists, account_already_exists } = globals;

    function closePopup() {
        const event = new CustomEvent("toggle-display-open", {
            detail: { message: 'header-signup' }
        });
        window.dispatchEvent(event);
    }

    function validateEmail(value): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValid = emailRegex.test(value.trim());

        setEmail(value);
        setIsEmailValid(isValid);

        return isValid;
    }

    async function handleClick() {
        setIsValidating(true);
        setActivationMessage('');

        const isValid = validateEmail(email);
        const activationResult = await checkCustomerActivationStatus(email);

        if (isValid && activationResult
            && activationResult.exists
            && !activationResult.isActivated
            && activationResult.activationEmailSent
        ) {
            setActivationMessage(activationResult.message);

        } else if (!activationResult) {
            setActivationMessage(email_already_exists);

        } else if (isValid) {
            setShowRegisterForm(true);
        }

        setIsValidating(false);
    }

    function showForgotPassword() {
        closePopup();
        const event = new CustomEvent("toggle-display-open", {
            detail: {
                message: {
                    type: 'reset-password',
                    data: { email }
                }
            }
        });

        window.dispatchEvent(event);
    }

    useEffect(() => {
        addEventListener("toggle-display-open", () => {
            setEmail('');
            setIsEmailValid(true);
            setShowRegisterForm(false);
        });
    }, []);

    return (
        <div>
            {!showRegisterForm
                ?   <div className="flex flex-col text-center">
                        <h4 className={`account__signin--title mx-auto mb-8 ${section.heading_font_class}`}>
                            {section.title}
                        </h4>

                        <div className="flex items-center justify-center mb-8">
                            <img
                                src={section?.image}
                                alt={section?.image?.alt}
                                width={section?.image_width || "100%"}
                                height="100%"
                            />
                        </div>

                        <p
                            className={`${section.description_font_class} mb-6`}
                            dangerouslySetInnerHTML={{ __html: section.description }}
                        />

                        {activationMessage &&
                            <p
                                className="mb-4 text-center b2"
                                style={{ color: activationMessage === email_already_exists ? 'red' : '#36573B' }}
                            >
                                {activationMessage === email_already_exists
                                    ?   <>
                                            <span className="px-4">
                                                {account_already_exists}
                                            </span>
                                        </>
                                    : <span>{activationMessage}</span>
                                }
                            </p>
                        }

                        {(!activationMessage || activationMessage !== email_already_exists) &&
                            <div className="flex flex-col gap-4 text-left">
                                    <div className={`account-page__input-container floating-input mb-1`}>
                                        <input
                                            type="email"
                                            id="login_email"
                                            name={"email"}
                                            placeholder={" "}
                                            className="account-page__input form-field"
                                            value={email}
                                            onChange={(e) => validateEmail(e.target.value)}
                                            required
                                        />
                                        <label htmlFor="email">Email</label>

                                        {!isEmailValid && (
                                            <div className="text-sm text-red-500">
                                                Please enter a valid email address.
                                            </div>
                                        )}
                                    </div>

                                    <button
                                        className="block w-full button btn-primary"
                                        disabled={isValidating}
                                        onClick={() => handleClick()}
                                    >
                                        {isValidating ? "VALIDATING..." : "CREATE AN ACCOUNT"}
                                    </button>

                                    <p className="text-center underline b3">
                                        <span onClick={() => closePopup()} className="cursor-pointer">
                                            Cancel
                                        </span>
                                    </p>
                            </div>
                        }

                        {activationMessage === email_already_exists &&
                            <div className="flex flex-col gap-4 text-left">
                                <div className={`account-page__input-container floating-input mb-4`}>
                                    <input
                                        type="email"
                                        id="login_email"
                                        name={"email"}
                                        placeholder={" "}
                                        className="account-page__input form-field"
                                        value={email}
                                        onChange={(e) => validateEmail(e.target.value)}
                                        required
                                    />
                                    <label htmlFor="email">Email</label>

                                    {!isEmailValid && (
                                        <div className="text-sm text-red-500">
                                            Please enter a valid email address.
                                        </div>
                                    )}
                                </div>

                                <button
                                    className="block w-full bg-black button btn-dark"
                                    onClick={() => {
                                        closePopup();
                                        const event = new CustomEvent("toggle-display-open", {
                                            detail: { message: 'header-signin' }
                                        });
                                        window.dispatchEvent(event);
                                    }}
                                >
                                    SIGN IN
                                </button>

                                <button
                                    className="block w-full button btn-primary"
                                    onClick={() => showForgotPassword()}
                                >
                                    FORGOT PASSWORD
                                </button>

                                <p className="text-center underline b3">
                                    <span onClick={() => closePopup()} className="cursor-pointer">
                                        Cancel
                                    </span>
                                </p>
                            </div>
                        }
                    </div>

                :   <div className="pt-4">
                        <div className="flex items-center justify-between gap-4 pb-6">
                            <span className="b1">{email}</span>
                            <span
                                className="underline cursor-pointer"
                                onClick={() => setShowRegisterForm(false)}
                            >
                                Change
                            </span>
                        </div>

                        <AccountRegisterForm
                            settings={settings}
                            email={email}
                            isPopup
                        />
                    </div>
            }


        </div>
    )
};


export default AccountRegisterPopup;
